import { useTranslation } from 'react-i18next';

export default function FeeCarryOver() {
  const { t } = useTranslation();
  return (
    <section className="relative py-14 md:py-18 bg-background-100">
      <div className="max-w-[860px] mx-auto px-8">
        <div className="border border-accent-500/20 bg-background-50 p-8 md:p-10 text-center">
          <div className="flex flex-col items-center gap-5">
            {/* Icon */}
            <span className="w-14 h-14 flex items-center justify-center">
              <i className="ri-arrow-go-forward-line text-accent-500 text-3xl"></i>
            </span>

            {/* Message */}
            <div>
              {String(t('seminar.fee.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-600 tracking-[0.06em] leading-relaxed mb-3 font-label">{__s}</p>))}
              <p className="font-heading text-lg md:text-xl text-accent-700 tracking-[0.06em] leading-relaxed">
                {t('seminar.fee.message')}<span className="text-xl md:text-2xl">{t('seminar.fee.amount')}</span>{t('seminar.fee.suffix')}
                <br className="sm:hidden" />
                {t('seminar.fee.target')}
                <br className="sm:hidden" />
                <span className="text-accent-600">{t('seminar.fee.action')}</span>{t('seminar.fee.end')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
